import { render, staticRenderFns } from "./AudioTest.vue?vue&type=template&id=1541ca22&scoped=true&"
import script from "./AudioTest.vue?vue&type=script&lang=js&"
export * from "./AudioTest.vue?vue&type=script&lang=js&"
import style0 from "./AudioTest.vue?vue&type=style&index=0&id=1541ca22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1541ca22",
  null
  
)

export default component.exports